import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { loadEvents } from '../../../../redux/actions'

// Eventi da defense.community, caricati una volta per tutto il sito (barra
// "prossimo evento" e pagina Eventi). Foto, team e Instagram sono statici.
const LoadCollections = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadEvents())
  }, [dispatch])

  return null
}

export default LoadCollections
